import api from './api'

export async function getCaptcha() {
  // Backend returns JSON: {"captcha_image": "data:image/png;base64,IVBORw0KGgo..."}
  // Request as JSON to get proper parsing
  const res = await api.get('/api/v1/auth/captcha', { responseType: 'json' })
  return res.data
}

export async function login({ username, password, captcha_code }) {
  const res = await api.post('/api/v1/auth/login', { username, password, captcha_code })
  return res.data
}

export function logout() {
  localStorage.removeItem('access_token')
}
